export const focusedOtherRollupAriaLabel = "QOeL1b";
export default {focusedOtherRollupAriaLabel};